import React, { PropsWithChildren, useEffect } from 'react'
import { Button, Text, Form, Icon } from '@lounge-fe/ui-kit'
import { Link } from 'react-router-dom'
import { SignupFormLayout } from '../SignupFormLayout'
import { PasswordFormProps } from './types'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

const PasswordFormFields: React.FC<PasswordFormProps> = ({ error }) => {
  const { t } = useTranslation()
  const { watch } = useFormContext()

  const [passwordValue] = watch(['site-password'])

  return (
    <>
      <Form.Input
        className="hidden"
        type="hidden"
        name="password"
        value={passwordValue}
      />
      <Form.Password
        id="site-password"
        autoComplete="site-password"
        className="mb-6"
        placeholder={t('account.password')}
        name="site-password"
        errorText={error}
      />
      <Button className="w-full" type="submit">
        {t('action.submit')}
      </Button>
    </>
  )
}

export const PasswordForm: React.FC<PropsWithChildren<PasswordFormProps>> = ({
  title,
  error,
  subtitle,
  content,
}) => {
  const { t } = useTranslation()

  return (
    <SignupFormLayout.FormContainer>
      <div className="mb-6">
        {title && (
          <Text variant="title-three" className="font-regular mb-4">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text variant="title-five" className="mb-4">
            {subtitle}
          </Text>
        )}
        {content && (
          <Text
            variant="body-lg"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
      <Form
        method="post"
        id="password-form"
        onSubmit={() => {
          const form = document.getElementById(
            'password-form',
          ) as HTMLFormElement | null

          form?.submit()
        }}
        autoComplete="off"
        className="mb-10"
      >
        <PasswordFormFields error={error} />
      </Form>
      <div className="text-center">
        <Text
          as={Link}
          to="/"
          variant="body-lg"
          className="inline-flex font-regular"
        >
          <Icon.Calendar className="mr-2" />
          {t('action.sign_up')}
        </Text>
      </div>
    </SignupFormLayout.FormContainer>
  )
}
